import script from "./AddValueTagsEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AddValueTagsEdit.vue?vue&type=script&setup=true&lang=js"

import "./AddValueTagsEdit.vue?vue&type=style&index=0&id=ae3307f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae3307f0"]])

export default __exports__